import { formatSalesValue } from "../../../utils/formatUtils";

const ActualCostingTable = ({
    data,
    type,
    actualAccuracy,
    costAccuracy,
    formatNumber,
    otherCost
}) => {
    const items = data?.items_actual_costing || [];
    const purchaseItems = data?.purchase_items?.deployed_items || [];

    const purchaseByItemName = purchaseItems.reduce((acc, purchaseItem) => {
        acc[purchaseItem.item_name] = purchaseItem;
        return acc;
    }, {});

    const totalWastage = items.reduce(
        (sum, item) => sum + (parseFloat(item.wastage_cost) || 0),
        0
    );

    const totalDiscrepancy = items.reduce(
        (sum, item) => sum + (parseFloat(item.discrepancy_cost) || 0),
        0
    );

    return (
        <div className="border p-2">
            <div className="font-semibold mb-1 text-sm text-center uppercase tracking-wider">
                ACTUAL {type.toUpperCase()} COSTING
            </div>

            <div className="rounded-md border overflow-x-auto max-h-[275px] tiny-scrollbar">
                <table className="min-w-full overflow-y-auto divide-y divide-gray-200 text-center">
                    <thead className="bg-gray-100 sticky top-0 z-10">
                        <tr>
                            <th className="p-2 font-medium text-gray-700 uppercase tracking-wider">
                                Item Name
                            </th>
                            <th className="p-2 font-medium text-gray-700 uppercase tracking-wider">
                                Received
                            </th>
                            <th className="p-2 font-medium text-gray-700 uppercase tracking-wider">
                                Value
                            </th>
                            <th className="p-2 font-medium text-gray-700 uppercase tracking-wider">
                                Opening
                            </th>
                            <th className="p-2 font-medium text-gray-700 uppercase tracking-wider">
                                Closing
                            </th>
                            <th className="p-2 font-medium text-gray-700 uppercase tracking-wider">
                                UOM
                            </th>
                            <th className="p-2 text-[10px] font-medium text-gray-700 uppercase tracking-wider whitespace-nowrap">
                                Opening Value | Closing Value
                            </th>
                        </tr>
                    </thead>

                    <tbody className="bg-white divide-y divide-gray-100">
                        {items.map((item, i) => {
                            const purchased = purchaseByItemName[item.item_name];

                            return (
                                <tr key={i} className="hover:bg-gray-50 tracking-wide">
                                    <td className="px-2 py-1">{item.item_name}</td>
                                    <td className="px-2 py-1">
                                        {purchased
                                            ? formatNumber(purchased.total_quantity)
                                            : "0"}
                                    </td>
                                    <td className="px-2 py-1">
                                        {purchased
                                            ? `Rs. ${formatSalesValue(purchased.total_amount)}`
                                            : "0"}
                                    </td>
                                    <td className="px-2 py-1">
                                        {formatNumber(item.opening_count)}
                                    </td>
                                    <td className="px-2 py-1">
                                        {formatNumber(item.physical_count)}
                                    </td>
                                    <td className="px-2 py-1">{item.uom}</td>
                                    <td className="px-2 py-1 whitespace-nowrap">
                                        OV={formatSalesValue(item.opening_cost)} : CV=
                                        {formatSalesValue(item.physical_cost)}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <div className="mt-2 px-2 grid grid-cols-2 gap-16 font-semibold tracking-wide">
                <div>
                    <div className="grid grid-cols-2 gap-x-2 gap-y-1 items-center">
                        <label className="font-semibold">
                            {type} Purchase:
                        </label>
                        <input
                            readOnly
                            value={formatSalesValue(data?.purchase_items?.summary?.total_value)}
                            className="border p-1 rounded w-40 text-center"
                        />

                        <label>Opening:</label>
                        <input
                            readOnly
                            value={formatSalesValue(data?.opening)}
                            className="border p-1 rounded w-full font-semibold text-center"
                        />

                        <label>Closing:</label>
                        <input
                            readOnly
                            value={formatSalesValue(data?.closing)}
                            className="border p-1 rounded w-full font-semibold text-center"
                        />

                        <label>Cost of Goods Sold:</label>
                        <input
                            readOnly
                            value={formatSalesValue(data?.cost_of_goods_sold)}
                            className="border p-1 rounded w-full font-semibold text-center"
                        />
                    </div>
                </div>

                <div>
                    <div className="grid grid-cols-2 gap-x-2 gap-y-1 items-center">
                        <label>Wastage:</label>
                        <input
                            readOnly
                            value={formatSalesValue(totalWastage)}
                            className="border p-1 rounded w-full font-semibold text-center"
                        />

                        <label>Discrepancies:</label>
                        <input
                            readOnly
                            value={formatSalesValue(totalDiscrepancy)}
                            className="border p-1 rounded w-full font-semibold text-center"
                        />

                        <label>Staff Consumption:</label>
                        <input
                            readOnly
                            value={formatSalesValue(data.employee_meal)}
                            className="border p-1 rounded w-full font-semibold text-center"
                        />

                        <label>Other Cost:</label>
                        <input
                            readOnly
                            value={formatSalesValue(otherCost)}
                            className="border p-1 rounded w-full font-semibold text-center"
                        />

                        <label>Actual {type} Cost %:</label>
                        <input
                            readOnly
                            value={`${actualAccuracy}%`}
                            className="border p-1 rounded w-full font-semibold text-center"
                        />

                        <label>Cost Accuracy %:</label>
                        <input
                            readOnly
                            value={`${formatSalesValue(costAccuracy)}%`}
                            className={`border p-1 rounded w-full font-semibold text-center ${costAccuracy < 80
                                ? "bg-red-200 text-red-800"
                                : costAccuracy <= 90
                                    ? "bg-yellow-200 text-yellow-800"
                                    : "bg-green-200 text-green-800"
                                }`}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ActualCostingTable;